import GridElement from "../GridElement";
import GridWrapper from "../GridWrapper";
import {
  getTotalPrize,
  isElevatedRound,
  isRoundNumber456,
  prizeCalculator,
  prizeCalculatorSeason3,
  prizeCalculatorPGA,
} from "../../utils/tournaments";
import styles from "./PrizeList.module.css";
import { Tournament } from "../../types/tournament";
import { Spacing } from "../GridWrapper/GridWrapper";
import {
  PRIZES_FINAL_SEASON_2,
  PRIZES_FINAL_SEASON_3,
} from "../../utils/constants";

interface PrizeListProps {
  tournament: Tournament;
  isPGATournament?: boolean;
}

const PrizeList = ({ tournament, isPGATournament }: PrizeListProps) => {
  const playersCount =
    tournament?.participants?.allInvitationsCount -
    tournament?.participants?.declinedCount -
    tournament?.participants?.withdrawnCount;

  const isElevated = isElevatedRound(tournament.season, tournament.name);
  const isFinalSeason2 =
    tournament.season === 2 &&
    tournament.name?.toLowerCase()?.includes("final");
  const isFinalSeason3 =
    tournament.season === 3 &&
    tournament.name?.toLowerCase()?.includes("final");
  const isRound456 = isRoundNumber456(tournament.name);

  const getPrizeTable = () => {
    if (tournament.season === 3) {
      return isPGATournament
        ? prizeCalculatorPGA(playersCount)
        : isFinalSeason3
        ? PRIZES_FINAL_SEASON_3
        : prizeCalculatorSeason3(playersCount);
    }

    if (isFinalSeason2) {
      return [...PRIZES_FINAL_SEASON_2, ...Array.from(Array(90)).map(() => 0)];
    }

    return prizeCalculator(
      playersCount,
      tournament.season,
      isElevated,
      isRound456
    );
  };

  return (
    <GridWrapper padding_top={Spacing.x_large} padding_bottom={Spacing.x_large}>
      <GridElement
        gridLayout={[
          [0, 1, 4, 2],
          [961, 7, 4, 2],
          [1401, 14, 6, 2],
        ]}
      >
        <GridElement
          gridLayout={[
            [0, 1, 4, 1],
            [961, 6, 6, 1],
            [1401, 12, 10, 1],
          ]}
        >
          <h1 className={styles.prizeListTitle}>Stroke play</h1>
        </GridElement>

        <div className={styles.prizeListSubTitleWrapper}>
          <h3 className={styles.prizeListSubTitle}>
            <span className={styles.prizeListSubTitleLabel}>Purse</span>
            <span className={styles.prizeListSubTitleValue}>
              $
              {getTotalPrize(
                playersCount,
                isElevated,
                isFinalSeason2,
                isPGATournament,
                isFinalSeason3
              ).toLocaleString("en-US")}
            </span>
          </h3>
          <h3 className={styles.prizeListSubTitle}>
            <span className={styles.prizeListSubTitleLabel}>Players</span>
            <span className={styles.prizeListSubTitleValue}>
              {isFinalSeason2 ? 100 : playersCount}
            </span>
          </h3>
        </div>
      </GridElement>
      <GridElement
        gridLayout={[
          [0, 1, 4, 3],
          [961, 5, 8, 3],
          [1401, 9, 16, 3],
        ]}
      >
        <ol className={styles.prizeList}>
          <li className={styles.prizeListItem}>
            <span>Position</span>
            <span>Prize money</span>
          </li>
          {getPrizeTable()?.map(
            (item: number, index: number) =>
              item > 0 && (
                <li key={index} className={styles.prizeListItem}>
                  <span>{index + 1}</span>
                  <span>${item.toLocaleString("en-US")}</span>
                </li>
              )
          )}
          {getPrizeTable()?.indexOf(0) !== -1 && (
            <li className={styles.prizeListItem}>
              <span>
                {getPrizeTable().indexOf(0) + 1}
                ...
                {getPrizeTable()?.length}
              </span>
              <span>$0</span>
            </li>
          )}
        </ol>
      </GridElement>
    </GridWrapper>
  );
};

export default PrizeList;
